import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Download, Logout } from "@mui/icons-material";

export default function PreAdmissionDashboard() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem("preAdmissionData");
    if (!storedData) {
      navigate("/pre-admission/student_login");
      return;
    }
    setData(JSON.parse(storedData));
  }, [navigate]);

  if (!data) return null;

  const { application, exam, interview } = data;

  // ✅ Logout
  const handleLogout = () => {
    localStorage.removeItem("preAdmissionData");
    navigate("/pre-admission/student_login");
  };

  return (
    <Box
      sx={{
        p: 3,
        maxWidth: 800,
        mx: "auto",
      }}
    >
      <Paper
        sx={{
          p: 3,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h5" fontWeight={600}>
            🎓 Welcome, {application.name}
          </Typography>
          <Button
            variant="outlined"
            color="error"
            startIcon={<Logout />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>

        {/* Application Info */}
        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6">🧾 Application Information</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography>Application No: {application.application_no}</Typography>
            <Typography>Class Applied: {application.class_applied}</Typography>
            <Typography>DOB: {application.dob}</Typography>
            <Typography>Mobile: {application.mobile_no}</Typography>
            <Typography>Status: {application.status}</Typography>
            <Typography>Payment: {application.payment_status}</Typography>
          </CardContent>
        </Card>

        {/* Exam Info */}
        {exam ? (
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="h6">🧮 Entrance Exam</Typography>
              <Divider sx={{ my: 1 }} />
              <Typography>Exam Name: {exam.exam_name}</Typography>
              <Typography>Date: {exam.exam_date}</Typography>
              <Typography>Venue: {exam.venue}</Typography>
              {exam.is_published === "1" ? (
                <>
                  <Typography>
                    Result:{" "}
                    <span
                      style={{
                        color:
                          exam.result_status === "passed" ? "green" : "red",
                        fontWeight: 600,
                      }}
                    >
                      {exam.result_status.toUpperCase()}
                    </span>
                  </Typography>
                  <Typography>Marks: {exam.marks_obtained}</Typography>
                  <Typography>Remarks: {exam.remarks}</Typography>
                </>
              ) : (
                <Typography color="text.secondary">
                  Result Not Published Yet
                </Typography>
              )}
            </CardContent>
          </Card>
        ) : (
          <Typography color="text.secondary" textAlign="center">
            No exam details found.
          </Typography>
        )}

        {/* Interview Info */}
        {interview ? (
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="h6">👨‍👩‍👧 Parent Interview</Typography>
              <Divider sx={{ my: 1 }} />
              <Typography>Date: {interview.interview_date}</Typography>
              <Typography>Time: {interview.interview_time}</Typography>
              <Typography>Venue: {interview.venue}</Typography>
              <Typography>
                Result:{" "}
                <span
                  style={{
                    color:
                      interview.result === "selected" ? "green" : "red",
                    fontWeight: 600,
                  }}
                >
                  {interview.result}
                </span>
              </Typography>
              <Typography>Remarks: {interview.remarks}</Typography>
            </CardContent>
          </Card>
        ) : (
          <Typography color="text.secondary" textAlign="center">
            No interview scheduled yet.
          </Typography>
        )}

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 3,
          }}
        >
          <Button
            variant="contained"
            startIcon={<Download />}
            color="primary"
            onClick={() => {
            const status =
                application.payment_status === "paid"
                ? "success"
                : application.payment_status === "pending"
                ? "pending"
                : "failed";

            navigate(
                `/pre-admission?status=${status}&app_id=${application.app_id}`
            );
            }}

          >
            📄 View Application Copy
          </Button>

          <Button
            variant="outlined"
            startIcon={<Download />}
            color="secondary"
            onClick={() => navigate("/pre-admission/admit-card")}
          >
            🎟 View Admit Card
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
